import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  /** Efecto "sello timbrado": entra con una rotación breve. */
  stamp?: boolean;
  as?: 'div' | 'li';
}
export function Reveal({
  children,
  delay = 0,
  className = '',
  stamp = false,
  as = 'div'
}: RevealProps) {
  const MotionTag = as === 'li' ? motion.li : motion.div;
  return <MotionTag initial={stamp ? {
    opacity: 0,
    rotate: -2.5,
    scale: 0.94
  } : {
    opacity: 0,
    y: 28
  }} whileInView={stamp ? {
    opacity: 1,
    rotate: 0,
    scale: 1
  } : {
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.65,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-164" data-mp="2jrrn2my2vica">
      {children}
    </MotionTag>;
}